import { Button } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DeleteBatchConfirmModal } from './DeleteBatchConfirmModal';
import { useDeleteBatchConfirm } from './useDeleteBatchConfirm';

interface Props {
	onDelete: () => void;
	isDeleting?: boolean;
	/** Side padding; the app Button's 8px when omitted. */
	px?: string;
}

/** "Delete batch", offered on a failed batch and on one that found nothing to review; it asks before deleting. */
export const DeleteBatchButton = ({ onDelete, isDeleting, px }: Props) => {
	const tCapManage = useTranslationCapManage();
	const confirm = useDeleteBatchConfirm(onDelete);

	return (
		<>
			<Button
				size="height-36"
				variant="default"
				fw={600}
				px={px}
				onClick={confirm.open}
				loading={isDeleting}
				data-testid={TEST_ELEMENT_IDS.DEALSTACK_AI_DELETE_BATCH_BUTTON}
			>
				{tCapManage('dealstack_ai.batch_delete.button')}
			</Button>
			<DeleteBatchConfirmModal
				opened={confirm.opened}
				onCancel={confirm.cancel}
				onConfirm={confirm.confirm}
			/>
		</>
	);
};
